// @flow

import * as React from 'react';
import CallButton from '../../components/CallButton';
import Config from '@insolus/config';

const CallButtonElement = (): React.Node => {
    const { Ad } = Config.get('data');
    return <CallButton ad={Ad} isMobile={Config.get('serverContext.isMobile')} />;
};

export default CallButtonElement;
